import { Navigate, Route, Routes } from 'react-router-dom';

import { LoginPage } from './features/auth/LoginPage';
import { ChangePasswordPage } from './features/auth/ChangePasswordPage';
import { RegisterPage } from './features/auth/RegisterPage';
import { ProfilePage } from './features/profile/ProfilePage';
import { AgentsPage } from './features/agents/AgentsPage';
import { AgentSetupPage } from './features/agents/AgentSetupPage';
import { ProjectsPage } from './features/projects/ProjectsPage';
import { BoardPage } from './features/board/BoardPage';
import { PersonalBoardPage } from './features/board/PersonalBoardPage';
import { LegacyBoardRedirect } from './features/board/LegacyBoardRedirect';
import { BacklogPage } from './features/backlog/BacklogPage';
import { IssuePage } from './features/issue/IssuePage';
import { SearchPage } from './features/search/SearchPage';
import { ReportsPage } from './features/reports/ReportsPage';
import { WikiPageView } from './features/wiki/WikiPage';
import { WikiSettingsPage } from './features/wiki/WikiSettingsPage';
import { UsersPage } from './features/admin/UsersPage';
import { MailPage } from './features/admin/MailPage';
import { AuditPage } from './features/admin/AuditPage';
import { ApiPage } from './features/admin/ApiPage';
import { GeneralSettingsPage } from './features/settings/GeneralSettingsPage';
import { BoardsSettingsPage } from './features/settings/BoardsSettingsPage';
import { ComponentsSettingsPage } from './features/settings/ComponentsSettingsPage';
import { WorkflowSettingsPage } from './features/settings/WorkflowSettingsPage';
import { MembersSettingsPage } from './features/settings/MembersSettingsPage';
import { DangerSettingsPage } from './features/settings/DangerSettingsPage';
import { IntegrationsSettingsPage } from './features/settings/IntegrationsSettingsPage';
import { ProjectAgentsSettingsPage } from './features/settings/ProjectAgentsSettingsPage';
import { ProjectLayout } from './features/settings/ProjectLayout';
import { NotFoundPage } from './features/NotFoundPage';
import { AdminLayout, AppLayout } from './layout/AppLayout';
import { RequireAdmin, RequireAuth } from './auth/RequireAuth';

/** Маршруты из docs/06 §2. */
export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/change-password" element={<ChangePasswordPage />} />

      <Route
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route path="/" element={<ProjectsPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/agents" element={<AgentsPage />} />
        <Route path="/agents/:id" element={<AgentSetupPage />} />
        {/* Моя доска: задачи текущего исполнителя из всех проектов (E18). */}
        <Route path="/my" element={<PersonalBoardPage />} />
        {/*
          Доска живёт по своему id: доски у проекта несколько, и ссылка на
          конкретную доску должна быть копируемой (docs/06 §2). Старый
          `/board` оставлен редиректом: ссылки из писем и закладок не ломаются.
        */}
        <Route path="/projects/:key/board" element={<LegacyBoardRedirect />} />
        <Route path="/projects/:key/boards/:boardId" element={<BoardPage />} />
        {/* Отдельная страница задачи: своя ссылка и полноэкранный вид. */}
        <Route path="/projects/:key/issues/:issueKey" element={<IssuePage />} />
        <Route path="/projects/:key/backlog" element={<BacklogPage />} />
        <Route path="/projects/:key/reports" element={<ReportsPage />} />
        <Route path="/projects/:key/wiki" element={<WikiPageView />} />
        <Route path="/projects/:key/wiki/:pageId" element={<WikiPageView />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/projects/:key/settings" element={<ProjectLayout />}>
          <Route index element={<Navigate to="general" replace />} />
          <Route path="general" element={<GeneralSettingsPage />} />
          <Route path="boards" element={<BoardsSettingsPage />} />
          <Route path="components" element={<ComponentsSettingsPage />} />
          <Route path="workflow" element={<WorkflowSettingsPage />} />
          <Route path="members" element={<MembersSettingsPage />} />
          <Route path="agents" element={<ProjectAgentsSettingsPage />} />
          <Route path="integrations" element={<IntegrationsSettingsPage />} />
          <Route path="wiki" element={<WikiSettingsPage />} />
          <Route path="danger" element={<DangerSettingsPage />} />
        </Route>
      </Route>

      <Route
        element={
          <RequireAdmin>
            <AdminLayout />
          </RequireAdmin>
        }
      >
        <Route path="/admin/users" element={<UsersPage />} />
        <Route path="/admin/mail" element={<MailPage />} />
        <Route path="/admin/audit" element={<AuditPage />} />
        <Route path="/admin/api" element={<ApiPage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
